const env = "dev";
export const config = {
    s3BaseUrl: "https://variantwebmedia.s3.ap-south-1.amazonaws.com",
    USER_LOGIN_DETAILS:'user_login_details',
    USER_PLAN_DETAILS:'user_plan_details',
    VARIANT_COUNT:'variant_count',
    // GOOGLE_CLIENT_ID_CALENDER:'171980855262-06sneiq2ejpmbrckkfd63p6tgo49nlb4.apps.googleusercontent.com'
    GOOGLE_CLIENT_ID_CALENDER:
    '864222325084-kfink5vp5fpqgb4ga60el6ceccasru7r.apps.googleusercontent.com',
    // '386833792353-8kn76iup8f0chi7ken5k7j6h911mn8uh.apps.googleusercontent.com/', old one
    FONT_BASE_URL : 'https://variantwebmedia.s3.ap-south-1.amazonaws.com/',
    APP_VERSION: '1.3.4',
    POLOTNO_VERSION: '2.36.1',
    invoiceUrl: "https://teedex.s3.ap-south-1.amazonaws.com",
}
